import {
  Box, Paper, Tab, Tabs,
  Typography,
} from '@mui/material';
import React, { useContext, useState } from 'react';
import UserContext from 'Shared/UserContext';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import ButtonApp from 'Shared/Button';
import AddIcon from '@mui/icons-material/Add';
import { useHistory } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ButtonMultiDownload from 'Shared/Button/ButtonMultiDownload';
import { toast } from 'react-toastify';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import BlockedOrders from '../BlockedOrders';
import Orders from '../Orders';
import OrdersControl from '../OrdersControl';
import useStyles from './style';
import TransformationBL from '../TransformationBL/TransformationBL';
import { exportExpeditionOrderEligible } from '../RecoveryServices';
import { TypeDocShip } from '../Orders/constants';

const options = [
  {
    key: 'BC',
    value: 1,
    label: (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <TypeDocShip type={1} />
        <Typography sx={{ ml: 0.5 }}>
          Bon De Commande
        </Typography>
      </Box>
    ),
  },
  {
    key: 'BL',
    value: 3,
    label: (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <TypeDocShip type={3} />
        <Typography sx={{ ml: 0.5 }}>
          Bon de Livraison
        </Typography>
      </Box>
    ),
  },
  {
    key: 'FA',
    value: 6,
    label: (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <TypeDocShip type={6} />
        <Typography sx={{ ml: 0.5 }}>
          Facture
        </Typography>
      </Box>
    ),
  },
  {
    key: 'BR',
    value: 4,
    label: (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <TypeDocShip type={4} />
        <Typography sx={{ ml: 0.5 }}>
          Bon De Retour
        </Typography>
      </Box>
    ),
  },
];
const RecoveryListTabs = () => {
  const { state } = useLocation();
  const {
    state: { user },
  } = useContext(UserContext);
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [openAddDocVente, setOpenAddDocVente] = useState(false);
  const [isDecompatalization, setIsDecompatalization] = useState(false);
  const [tab, setTab] = useState(state ? state.tab : 1);

  const handleClickOpen = (decompatalization = false) => {
    setIsDecompatalization(decompatalization);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleChange = (event, newValue) => {
    setTab(newValue);
  };
  const isCommercialOrSales = ['COMMERCIAL', 'SALES'].includes(user.role);
  const isSAV = ['SAV'].includes(user.role);

  const onHandleAddDoc = (docType) => {
    history.push('/payment/orders/add', { docType: docType.value });
  };
  const onHandleExportTransport = async () => {
    try {
      setLoading(true);
      await exportExpeditionOrderEligible();
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoading(false);
    }
  };

  const classes = useStyles();
  return (
    <Paper elevation={0} classes={{ root: classes.paper }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Tabs
          value={tab}
          sx={{ flexGrow: 1 }}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          TabIndicatorProps={{ style: { backgroundColor: '#2188CC' } }}
        >
          {!isCommercialOrSales && (
            <Tab
              classes={{
                root: classes.tab,
                selected: classes.tabSelected,
                wrapper: classes.tabWrapper,
              }}
              label="Commandes"
              value={1}
            />
          )}
          {!isCommercialOrSales && (
            <Tab
              classes={{
                root: classes.tab,
                selected: classes.tabSelected,
                wrapper: classes.tabWrapper,
              }}
              label="Contrôles"
              value={3}
            />
          )}
          {!isCommercialOrSales && !isSAV && (
            <Tab
              classes={{
                root: classes.tab,
                selected: classes.tabSelected,
                wrapper: classes.tabWrapper,
              }}
              label="Commandes bloquées"
              value={2}
            />
          )}
        </Tabs>
        {isSAV && (
        <ButtonApp
          startIcon={loading && (
          <RotateLeftIcon sx={{
            animation: 'spin 2s linear infinite',
            '@keyframes spin': {
              '0%': {
                transform: 'rotate(360deg)',
              },
              '100%': {
                transform: 'rotate(0deg)',
              },
            },
          }}
          />
          )}
          label="Exporter situation transport"
          onClick={onHandleExportTransport}
          style={{ height: 32, background: '#FFF', color: '#037EC9' }}
          disabled={loading}
        />
        ) }
        <ButtonApp
          onClick={() => handleClickOpen(true)}
          label="décomptabiliser"
          style={{ height: 32, marginLeft: 10, marginRight: 10 }}
        />
        <ButtonApp
          onClick={() => handleClickOpen(false)}
          label="Transformer documents"
          style={{ height: 32, marginRight: 10 }}
        />
        {isSAV && (
          <ButtonMultiDownload
            startIcon={<AddIcon />}
            endIcon={<KeyboardArrowDownIcon />}
            uploadItems={options}
            handleUpload={onHandleAddDoc}
            label="Ajouter un document"
            defaultBtn
          />
        ) }
      </Box>
      {tab === 1 && !isCommercialOrSales && <Orders />}
      {tab === 3 && !isCommercialOrSales && <OrdersControl />}
      {tab === 2 && !isCommercialOrSales && !isSAV && <BlockedOrders />}
      {open && (
      <TransformationBL
        handleClose={handleClose}
        isDecompatalization={isDecompatalization}
      />
      )}
    </Paper>
  );
};

export default RecoveryListTabs;
